<template>
    <div>
        <el-form
                ref="form"
                :model="form"
                :rules="rules"
                v-loading="isBusy"
                element-loading-spinner="el-icon-loading"
                label-width="170px"
        >
            <el-form-item label="Title" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="Description" prop="description">
                <el-input type="textarea" v-model="form.description"></el-input>
            </el-form-item>

            <el-form-item label="File:" prop="file">
                <audio-file-input v-model="form.file" v-if="!isEditMode"/>
                <file-item v-else :metadata="model.metadata" :url="model.url"></file-item>
            </el-form-item>

            <el-form-item label="Shared" prop="shared">
                <el-switch
                        v-model="form.shared"
                        type="text"
                        :active-value="1"
                        :inactive-value="0"
                ></el-switch>
            </el-form-item>
        </el-form>
        <el-button type="primary" @click="store">Save</el-button>
    </div>
</template>

<script>
  import BaseForm from '../form';
  import AudioFileInput from './file-input';
  import FileItem from './file-item';

  export default {
    extends: BaseForm,

    components: {
      AudioFileInput,
      FileItem,
    },

    data() {
      const form = {
        title: null,
        description: null,
        file: null,
        shared: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
        collapseFile: null,
      };
    },

    computed: {
      metadata() {
        return _.assign({}, model.metadata || {});
      },
    },

    methods: {
      /**
       * @param {Object} model
       */
      initForm(model) {
        this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
      },

      /**
       * @return {Object}
       */
      getForm() {
        return _.chain({...this.form, _method: this.method})
          .reduce((formData, value, name) => {
            !_.isNull(value) && formData.append(name, value);

            return formData;
          }, new FormData())
          .value();
      },
    },
  }
</script>

